<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="新增描述"
      :innerHeight="300"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <el-form :model="formData" label-width="100px" :rules="rules" ref="ruleForm" size="mini">
        <el-form-item label="品类" prop="category">
          <el-select v-model="formData.category" filterable>
            <el-option :label="item" :value="item" v-for="(item, index) in categoryOptions" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="维度" prop="tag">
          <el-select v-model="formData.tag">
            <el-option :label="item.label" :value="item.value" v-for="(item, index) in tagOptions" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <template  v-for="(item, index) in formData.optionDesc">
          <el-form-item label="描述" :key="index" required prop="optionDesc">
            <el-input v-model.trim="formData.optionDesc[index]"></el-input>
            <el-link type="primary"
              :underline="false"
              @click="formData.optionDesc.push('')"
              v-if="index === formData.optionDesc.length - 1"
            >&nbsp;添加</el-link>
            <el-link 
              type="primary" 
              :underline="false" 
              @click="formData.optionDesc.splice(index,1)"
              v-else
              >&nbsp;删除</el-link>
          </el-form-item>
        </template>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
import validator from 'validator';
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible'],
  data() {
    const optionDescValidate = (rule, value, callback) => {
      if(value && value.indexOf('') > -1) {
        callback(new Error('不能为空'))
      }else{
        callback()
      }
    }
    return {
      dialogVisible: false,
      formData: {
        optionDesc: ['']
      },
      rules: {
        category: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
        tag: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
        optionDesc: [
          { validator: optionDescValidate, trigger: 'change' }
        ],
      },
      categoryOptions: [],
      tagOptions: [],
    }
  },
  mounted() {
    this.dialogVisible = this.visible;
    this.getOptions();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.$refs['ruleForm'].validate(valid=>{
        if(valid) {
          this.submit();
        }else{

        }
      })
    },
    submit() {
      this.$q.product.addConfigDescribe({data: this.formData})
      .then(res=>{
        if(res.code == 200) {
          this.$message.success('新增成功');
          this.updateVal();
          this.$emit('complete')
        }else{
          this.$message.error(res.message);
        }
      })
    },
    getOptions() {
      this.$q.product.getCategoryTag()
      .then(res=>{
        const {category, tag} = res.data;
        this.categoryOptions = category;
        this.tagOptions = Object.keys(tag).map(k=>{
          return {
            label: tag[k],
            value: k
          }
        });
      })
    }
  }
}
</script>

<style>

</style>